module.exports = __webpack_public_path__ + "img/ctrl-r-theta-stub-up-1.305e45ac.svg";